import { render, staticRenderFns } from "./HeaderTaxInvoice.vue?vue&type=template&id=753030da"
import script from "./HeaderTaxInvoice.vue?vue&type=script&lang=js"
export * from "./HeaderTaxInvoice.vue?vue&type=script&lang=js"
import style0 from "./HeaderTaxInvoice.vue?vue&type=style&index=0&id=753030da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports